import type { FunctionComponent } from "react";
import { Button } from "@kanda-libs/ks-design-library";
import Link from "components/shared/Link";
import { URLS } from "common/constants";
import { useSelector } from "react-redux";
import { selectors } from "store";
import paymentSelectors from "store/selectors/payments";

const PaymentJobLink: FunctionComponent = function () {
  const isLoading = useSelector(selectors.getIsLoading);
  const payment = useSelector(paymentSelectors.getFormattedPayment);

  return (
    <Link to={URLS.JOB.replace("{id}", payment?.jobId || "")}>
      <Button.Text
        id="staff-go-to-job"
        label="Go to job"
        size={40}
        className="w-40"
        disabled={isLoading || !payment?.jobId}
        isLoading={isLoading}
      />
    </Link>
  );
};

export default PaymentJobLink;
